module.exports = __webpack_public_path__ + "img/contacts-1.410bc87b.svg";